(() => {
  let observer;

  const enhanceMessengerButton = () => {
    const button = document.querySelector(
      '#gb-widget-6810 a[data-component-name="BaseButtonActivator"]'
    );

    if (!button) return false;

    if (button.getAttribute('role') === 'button') return true;

    button.setAttribute('role', 'button');
    button.setAttribute('tabindex', '0');
    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        button.click();
      }
    });

    return true;
  };

  if (enhanceMessengerButton()) return;

  observer = new MutationObserver(() => {
    if (enhanceMessengerButton()) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 60000);
})();
